import truncate from 'lodash.truncate';
import Head from 'next/head';
import React from 'react';

interface IProps {
  title?: string;
  description: string;
  image?: string;
  imageAlt?: string;
  author?: string;
  seoTitle?: string;
  siteName?: string;
}

const Meta = ({
  title,
  description,
  image,
  imageAlt,
  author,
  seoTitle,
  siteName,
}: IProps) => {
  const meta = [
    { property: 'og:title', content: seoTitle ?? title },
    { property: 'og:site_name', content: siteName ?? 'Landsbankinn.is' },
    { property: 'og:type', content: 'website' },
    /* { property: 'fb:app_id', content: '' }, */
    { property: 'fb:admins', content: '100003112871506' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:site', content: '@landsbankinn' },
  ];
  const shareImage = image ? image : null;

  if (description) {
    const truncatedDescription = truncate(description.replace(/\n+/g, ' '), {
      length: 300,
      separator: '. ',
    });

    meta.push(
      { name: 'description', content: truncatedDescription },
      { property: 'og:description', content: truncatedDescription },
      { name: 'twitter:description', content: truncatedDescription },
    );
  }

  if (shareImage) {
    meta.push(
      { property: 'og:image', content: shareImage },
      { property: 'og:image:width', content: '1200px' },
      { property: 'og:image:height', content: '630px' },
      { property: 'og:image:alt', content: imageAlt },
      { name: 'twitter:image', content: shareImage },
    );
  }

  if (author) {
    meta.push({ name: 'author', content: author });
  }

  return (
    <Head>
      <title>{title}</title>
      {meta.map((item, index) => (
        <meta key={`meta-${index}`} {...item} />
      ))}
      <link rel="image_src" href={shareImage ?? undefined} />
    </Head>
  );
};

export default Meta;
